<template>
  <HorizontalScroller class="CarouselItemsScroller">
    <div ref="itemsContainer" class="itemsContainer">
      <div class="items">
        <slot></slot>
      </div>
    </div>
  </HorizontalScroller>
</template>

<script>
import HorizontalScroller from '~/vue-components/shared/HorizontalScroller.vue'

export default {
  components: {
    HorizontalScroller,
  },
  props: {
    numItems: Number,
    targetItemIndex: Number,
  },
  watch: {
    targetItemIndex(value) {
      const scrollFraction = value / (this.numItems - 1)
      const { width: viewWidth } = this.$el.getBoundingClientRect()
      const { width: fullWidth } = this.$refs.itemsContainer.getBoundingClientRect()
      const left = scrollFraction * (fullWidth - viewWidth)
      this.$el.scrollTo({ left, behavior: 'smooth' });
    }
  },
}
</script>

<style scoped>

.itemsContainer {
  min-width: fit-content;
  padding-left: var(--gutter-width);
  padding-right: var(--gutter-width);
}

.items {
  display: flex;
  column-gap: var(--spacing-8);
}
</style>
